import { render, staticRenderFns } from "./koditem4a.vue?vue&type=template&id=1f75161b&scoped=true"
import script from "./koditem4a.vue?vue&type=script&lang=js"
export * from "./koditem4a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75161b",
  null
  
)

export default component.exports